'use client';

import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@crehana/compass.ui/v2';

import AlertTriangle from '@crehana/compass.icons.outline/AlertTriangle';
import { useTranslationSharedCandidateForm } from '../i18n/use-translations';

type TEmailValidationPopUpProps = {
  // Email to be validated
  email: string;
  // Boolean value that indicates whether the dialog is open or not
  open: boolean;
  // Function to set the state of the dialog's visibility (open/close)
  onOpenChange: React.Dispatch<React.SetStateAction<boolean>>;
};
export const EmailValidationPopUp: React.FC<TEmailValidationPopUpProps> = ({
  email,
  open,
  onOpenChange,
}) => {
  const { t } = useTranslationSharedCandidateForm(); // translation hook

  // Function to close the dialog
  const close = () => {
    onOpenChange(false); // Close the dialog
  };

  return (
    <Dialog
      open={open}
      onOpenChange={open => {
        onOpenChange(open);
      }}
    >
      {/* Dialog to confirm the email validation action */}
      <DialogContent size="sm">
        <DialogHeader className="tw-pt-4.8 tw-flex tw-flex-col tw-items-center tw-justify-center">
          {/* Icon indicating alert (alert triangle icon) */}
          <div className="tw-flex tw-justify-center tw-items-center tw-bg-warning-100 tw-rounded-full tw-h-[56px] tw-w-[56px]">
            <div className="tw-flex tw-justify-center tw-items-center tw-bg-warning-300 tw-rounded-full tw-h-[46px] tw-w-[46px]">
              <AlertTriangle size={28} className="tw-text-warning-600" />
            </div>
          </div>
          {/* Title of the dialog */}
          <DialogTitle className="tw-flex tw-items-center tw-justify-center">
            <h2 className="tw-font-subtitle2">{t('EMAIL_VALIDATION_TITLE')}</h2>
          </DialogTitle>
        </DialogHeader>
        {/* Description of the dialog explaining the email validation action */}
        <div className="tw-flex tw-text-center tw-px-2.4 tw-pt-1.2 tw-pb-2.4 tw-justify-center">
          <p className="tw-font-subtitle5 tw-font-normal">
            <span className="tw-font-semibold tw-mr-0.4">{email}</span>
            {t('EMAIL_VALIDATION_DESCRIPTION')}
          </p>
        </div>
        {/* Action buttons at the bottom of the modal */}
        <DialogFooter>
          {/* Button to go back to the form */}
          <Button
            type="button"
            size="sm"
            variant="primary"
            onClick={() => {
              close();
            }}
          >
            {t('BACK_TO_FORM')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
